import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import LOGO_LOTTE from '@di-shared/assets/img/car_management/logo_lotte.png';
import LOGO_MERITZ from '@di-shared/assets/img/car_management/logo_meritz.png';
import LOGO_SAMSUNG from '@di-shared/assets/img/car_management/logo_samsung.png';
import LOGO_CARROT from '@di-shared/assets/img/car_management/logo_carrot.png';
import LOGO_HANA from '@di-shared/assets/img/car_management/logo_hana.png';
import LOGO_HANHWA from '@di-shared/assets/img/car_management/logo_hanhwa.png';
import LOGO_HEUNGKUK from '@di-shared/assets/img/car_management/logo_heungkuk.png';
import LOGO_HI from '@di-shared/assets/img/car_management/logo_hi.png';
import LOGO_AXA from '@di-shared/assets/img/car_management/logo_axa.png';
import LOGO_DB from '@di-shared/assets/img/car_management/logo_db.png';
import LOGO_KB from '@di-shared/assets/img/car_management/logo_kb.png';
import ImageSelector from '@di-shared/features/common/ImageSelector';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500; // 개발자가 수동으로 계산한 높이

function BatteryEmergencyCallBottomSheet() {
  const {t} = useInferableTranslation();

  const phoneBook = [
    {name: t('T30314'), tel: import.meta.env.VITE_EMERGENCY_TEL_LOTTE, img: LOGO_LOTTE},
    {name: t('T30315'), tel: import.meta.env.VITE_EMERGENCY_TEL_MERITZ, img: LOGO_MERITZ},
    {name: t('T30316'), tel: import.meta.env.VITE_EMERGENCY_TEL_SAMSUNG, img: LOGO_SAMSUNG},
    {name: t('T30317'), tel: import.meta.env.VITE_EMERGENCY_TEL_CARROT, img: LOGO_CARROT},
    {name: t('T30318'), tel: import.meta.env.VITE_EMERGENCY_TEL_HANA, img: LOGO_HANA},
    {name: t('T30319'), tel: import.meta.env.VITE_EMERGENCY_TEL_HANHWA, img: LOGO_HANHWA},
    {name: t('T30320'), tel: import.meta.env.VITE_EMERGENCY_TEL_HEUNGKUK, img: LOGO_HEUNGKUK},
    {name: t('T30321'), tel: import.meta.env.VITE_EMERGENCY_TEL_HYUNDAI, img: LOGO_HI},
    {name: t('T30322'), tel: import.meta.env.VITE_EMERGENCY_TEL_AXA, img: LOGO_AXA},
    {name: t('T30323'), tel: import.meta.env.VITE_EMERGENCY_TEL_DB, img: LOGO_DB},
    {name: t('T30324'), tel: import.meta.env.VITE_EMERGENCY_TEL_KB, img: LOGO_KB},
  ];

  function closeBottomSheet() {
    window.bottomSheetClose(null);
  }

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <div className="bottom_sheet">
        <div className="bottom_sheet_header">
          <h2 className="bottom_sheet_title">{t('T30135')}</h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label={t('T10017')}
            onClick={() => closeBottomSheet()}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
          <div className="emergency_contact_brand">
            <div className="emergency_contact_item">
              <a
                href={`tel:${import.meta.env.VITE_EMERGENCY_TEL_BRAND}`}
                className="emergency_contact_btn"
              >
                <div className="emergency_contact_logo">
                  <ImageSelector
                    className="emergency_contact_img"
                    alt="emergency_contact_img"
                    kiaLightSrc={() => import('@di-shared/assets/img/car_management/logo_brand.png')}
                    kiaDarkSrc={() => import('@di-shared/assets/img/car_management/logo_brand.png')}
                    hyundaiLightSrc={() => import('@di-shared/assets/img/car_management/hyundai/logo_brand.png')}
                    hyundaiDarkSrc={() => import('@di-shared/assets/img/car_management/hyundai/logo_brand.png')}
                    genesisLightSrc={() => import('@di-shared/assets/img/car_management/genesis/logo_brand.png')}
                    genesisDarkSrc={() => import('@di-shared/assets/img/car_management/genesis/logo_brand.png')}
                  />
                </div>
                <div className="emergency_contact_info">
                  <span className="emergency_contact_title">{t('T30147')}</span>
                  <span className="emergency_contact_phone">{import.meta.env.VITE_EMERGENCY_TEL_BRAND}</span>
                </div>
                <span className="ic ic_call_20px"></span>
              </a>
            </div>
          </div>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <ul className="emergency_contact_list">
              {phoneBook.map(({name, tel, img}) => (
                <li
                  className="emergency_contact_item"
                  key={name}
                >
                  <a
                    href={`tel:${tel}`}
                    className="emergency_contact_btn"
                  >
                    <div className="emergency_contact_logo">
                      <img
                        src={img}
                        className="emergency_contact_img"
                        alt=""
                      />
                    </div>
                    <div className="emergency_contact_info">
                      <span className="emergency_contact_title">{name}</span>
                      <span className="emergency_contact_phone">{tel}</span>
                    </div>
                    <span className="ic ic_call_20px"></span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default BatteryEmergencyCallBottomSheet;
